<form #f="ngForm" action="#">
    <div class="form-group">
        <label for="id">Department Id</label>
        <input class="form-control" type="text" name="id" [(ngModel)]="id" readonly>
    </div>

    <div class="form-group">
        <label for="name">Department Name</label>
        <div>
            <input required minlength="3" type="text"
            id="name" name="name" class="form-control"
            [(ngModel)]="name"
            placeholder="Enter Department name">
        </div>
    </div>


    <div class="modal-footer">
        <div class="form-group">
            <input hidden="f." data-dismiss="@modal" *ngIf="Department.id == 0"
            type="submit" value="Add" class="btn btn-primary"
                (click)="addDepartment()" />
            <input data-dismiss="@modal" *ngIf="Department.id != 0"
            type="submit" value="Update" class="btn btn-primary"
                (click)="updateDepartment()" />
        </div>
    </div>

    {{ f.value | json}}
    {{ name }}
    {{ id }}
</form>

<!-- <form><div class="form-group"><label for="email">Email Address</label> <input class="form-control" id="email" type="text" name="email"[(value)]="email" [(ngModel)]="email" /> </div><div class="form-group"><label for="password">Password</label> <input class="form-control" type="text" id="password" name="password"[(ngModel)]="password" value="{{password}}" /> </div><div class="btn-group"> <input class="btn btn-primary" type="submit" name="Submit" value="Submit" /> <inputclass="btn btn-danger" type="reset" name="Reset" value="Reset" /> </div></form> -->
